<template>
  <v-card class="pa-6">
    <v-card-text>
      <p class="mb-0">
        Delete denied. A default network is required.
      </p>
    </v-card-text>

    <v-card-actions class="justify-center">
      <v-btn
        color="primary"
        outlined
        @click.stop="cancelDeleteNetwork"
      >
        OK
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import NetworkMixin from 'src/network/store/utils/networks-mixin'

export default {
  name: 'NetworkDeny',
  mixins: [
    NetworkMixin,
  ],
}
</script>
